var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPwdBtn1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 56,
    viewBox: "0 0 300 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_691_953)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 56,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 282 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 50,
    width: 6,
    height: 6,
    transform: "rotate(-90 288 50)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 294 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 288 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 56,
    width: 6,
    height: 6,
    transform: "rotate(-90 294 56)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4 36V19.2H53.72V21.168H45.56V26.352H52.976V28.32H45.56V34.032H53.72V36H43.4ZM55.8762 36V23.736H57.9162V24.984C58.5642 24.072 59.6442 23.52 61.3002 23.52C62.9082 23.52 64.1802 24.168 64.9483 25.272C65.6683 24.336 66.7962 23.52 68.9563 23.52C71.6683 23.52 73.5642 25.344 73.5642 28.152V36H71.5243V28.608C71.5243 26.544 70.5882 25.44 68.6443 25.44C67.0122 25.44 65.7643 26.328 65.7643 28.608V36H63.7243V28.608C63.7243 26.544 62.7882 25.44 60.8442 25.44C59.2122 25.44 57.9162 26.328 57.9162 28.608V36H55.8762ZM80.2897 36.216C77.2177 36.216 75.2497 34.344 75.2497 31.08V28.656C75.2497 25.392 77.2177 23.52 80.2897 23.52C81.5137 23.52 82.5457 23.88 83.3137 24.552V23.736H85.3537V36H83.3137V35.184C82.5457 35.856 81.5137 36.216 80.2897 36.216ZM77.2897 31.08C77.2897 33.576 78.5137 34.296 80.2897 34.296C81.9457 34.296 83.3137 33.576 83.3137 31.08V28.656C83.3137 26.4 81.9457 25.44 80.2897 25.44C78.5137 25.44 77.2897 26.4 77.2897 28.656V31.08ZM87.8684 36V23.736H89.8844V36H87.8684ZM87.7484 21.192V18.84H90.0044V21.192H87.7484ZM95.4262 36C93.5302 36 92.6422 35.016 92.6422 33.504V18.24H94.6822V34.08H96.7702V36H95.4262ZM102.559 36V23.736H104.599V24.984C105.247 24.072 106.327 23.52 107.983 23.52C109.591 23.52 110.863 24.168 111.631 25.272C112.351 24.336 113.479 23.52 115.639 23.52C118.351 23.52 120.247 25.344 120.247 28.152V36H118.207V28.608C118.207 26.544 117.271 25.44 115.327 25.44C113.695 25.44 112.447 26.328 112.447 28.608V36H110.407V28.608C110.407 26.544 109.471 25.44 107.527 25.44C105.895 25.44 104.599 26.328 104.599 28.608V36H102.559ZM126.996 36.216C123.924 36.216 121.932 34.344 121.932 31.08V28.656C121.932 25.392 123.924 23.52 126.996 23.52C129.876 23.52 131.964 25.152 132.012 28.656V30.6H123.972V31.08C123.972 33.576 125.22 34.296 126.996 34.296C128.484 34.296 129.732 33.768 129.948 32.136H131.988C131.772 34.728 129.708 36.216 126.996 36.216ZM123.972 28.8H129.972V28.656C129.924 26.208 128.604 25.392 126.996 25.392C125.22 25.392 123.972 26.208 123.972 28.656V28.8ZM142.585 36.216C139.513 36.216 137.545 34.344 137.545 31.08V28.656C137.545 25.392 139.513 23.52 142.585 23.52C143.809 23.52 144.841 23.88 145.609 24.552V23.736H147.649V36H145.609V35.184C144.841 35.856 143.809 36.216 142.585 36.216ZM139.585 31.08C139.585 33.576 140.809 34.296 142.585 34.296C144.241 34.296 145.609 33.576 145.609 31.08V28.656C145.609 26.4 144.241 25.44 142.585 25.44C140.809 25.44 139.585 26.4 139.585 28.656V31.08ZM158.923 36.216C156.019 36.216 153.979 34.8 153.907 31.944H155.923C155.923 33.576 157.171 34.296 158.923 34.296C160.699 34.296 161.731 33.552 161.731 32.52C161.731 31.776 161.203 31.248 160.099 30.96L157.219 30.24C155.467 29.808 154.411 28.728 154.411 26.976C154.411 25.032 155.995 23.52 158.803 23.52C161.587 23.52 163.483 25.152 163.483 27.48H161.515C161.443 26.04 160.339 25.368 158.803 25.368C157.171 25.368 156.355 26.088 156.355 26.976C156.355 27.888 157.051 28.2 157.915 28.416L160.531 29.064C162.619 29.592 163.771 30.648 163.771 32.52C163.771 34.632 161.971 36.216 158.923 36.216ZM165.565 36V23.736H167.581V36H165.565ZM165.445 21.192V18.84H167.701V21.192H165.445ZM174.514 41.712C171.37 41.712 169.834 39.912 169.762 37.56H171.778C171.874 38.736 172.354 39.864 174.514 39.864C176.866 39.864 177.442 38.64 177.442 37.032V35.184C176.674 35.856 175.642 36.216 174.418 36.216C171.346 36.216 169.378 34.344 169.378 31.08V28.656C169.378 25.392 171.346 23.52 174.418 23.52C175.642 23.52 176.674 23.88 177.442 24.552V23.736H179.482V37.08C179.482 39.648 178.018 41.712 174.514 41.712ZM171.418 31.08C171.418 33.336 172.882 34.296 174.418 34.296C176.074 34.296 177.442 33.336 177.442 31.08V28.656C177.442 26.16 176.074 25.44 174.418 25.44C172.882 25.44 171.418 26.16 171.418 28.656V31.08ZM182.117 36V23.736H184.157V24.984C184.805 24.072 185.981 23.52 187.613 23.52C190.325 23.52 192.125 25.344 192.125 28.152V36H190.085V28.608C190.085 26.544 189.101 25.44 187.157 25.44C185.525 25.44 184.157 26.328 184.157 28.608V36H182.117ZM194.523 29.904V28.032H201.867V29.904H194.523ZM204.383 36V23.736H206.399V36H204.383ZM204.263 21.192V18.84H206.519V21.192H204.263ZM209.157 36V23.736H211.197V24.984C211.845 24.072 213.021 23.52 214.653 23.52C217.365 23.52 219.165 25.344 219.165 28.152V36H217.125V28.608C217.125 26.544 216.141 25.44 214.197 25.44C212.565 25.44 211.197 26.328 211.197 28.608V36H209.157ZM229.17 36C227.274 36 226.386 35.016 226.386 33.504V18.24H228.426V34.08H230.514V36H229.17ZM231.599 36V23.736H233.615V36H231.599ZM231.479 21.192V18.84H233.735V21.192H231.479ZM236.373 36V23.736H238.413V24.984C239.061 24.072 240.237 23.52 241.869 23.52C244.581 23.52 246.381 25.344 246.381 28.152V36H244.341V28.608C244.341 26.544 243.357 25.44 241.413 25.44C239.781 25.44 238.413 26.328 238.413 28.608V36H236.373ZM258.595 23.976L251.635 29.376L258.739 35.76V36H256.099L251.035 31.464V36H249.019V18.24H251.035V27.456L255.763 23.736H258.595V23.976Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 299.5,
    height: 55.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_691_953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPwdBtn1);
export default __webpack_public_path__ + "static/media/ResetPwdBtn1.c7017af69c08de42638a7c2f7d0d6d53.svg";
export { ForwardRef as ReactComponent };